/*###########################################################################
// Script handling
//#########################################################################*/

import { Formie } from '../../../vendor/verbb/formie/src/web/assets/frontend/src/js/formie-lib'
import { inViewport } from '../utilities/_inViewport'
import { throttle } from '../utilities/_throttleDebounce'

const scriptHandling = {
	scriptsLoaded: [],
	mapAssets: null,

	init() {
		const self = this

		const formieForms = document.querySelectorAll('form[data-fui-form]')
		if (formieForms !== null) {
			for (let i = 0; i < formieForms.length; i++) {
				const formieForm = formieForms[i]

				const formieInstance = new Formie()
				formieInstance.initForms(formieForm)

				document.addEventListener('onFormieInit', (event) => {
					// Parse form data for form hash ID
					const formieData = JSON.parse(formieForm.getAttribute('data-fui-form'))

					// Refresh the necessary bits that are statically cached (CSRF inputs, captchas, etc)
					formieInstance.refreshForCache(formieData.formHashId);

					if (formieForm.hasAttribute('data-brochure-form')) {
						formieForm.addEventListener('onAfterFormieSubmit', (e) => {
							window.brochureForm.handleFormSubmit(e)
						})
					}
				});
			}
		}

		if (self.mapAssets !== null) {
			const autoCompleteInput = document.querySelector('[data-places-autocomplete]')
			if (autoCompleteInput !== null) {
				window.addEventListener('scroll', throttle(function() {
					if (inViewport(autoCompleteInput, -window.innerHeight) && !self.scriptsLoaded.includes(0)) {
						console.log('in view');

						self.addScript(self.mapAssets[0].src, function() {
							self.scriptsLoaded.push(0)

							setTimeout(function() {
								new google.maps.places.Autocomplete(
									(autoCompleteInput),
									{
										types: ['geocode'],
										componentRestrictions: { country: 'uk' }
									}
								);
							}, 500)
						})
					}
				}, 200))
			} else if (autoCompleteInput !== null) {
				setTimeout(function() {
					new google.maps.places.Autocomplete(
						(autoCompleteInput),
						{
							types: ['geocode'],
							componentRestrictions: { country: 'uk' }
						}
					);
				}, 500)
			}
		}
	},

	addScript(src, onload) {
		const self = this

		const script = document.createElement('script')
		script.charset = 'utf-8'
		script.type = 'text/javascript'
		script.src = src

		// Append the script to the head
		document.head.appendChild(script)

		script.onload = onload
	}
}

window.addEventListener('load', function() {
	const mapAssets = document.querySelector('script[data-map-assets]')
	if (mapAssets !== null) {
		scriptHandling.mapAssets = JSON.parse(mapAssets.getAttribute('data-map-assets'))
	}
})

initComponent(() => {
	scriptHandling.init()
})
